import json from "../../../resources/mock-data/autosuggest-orders.json";

jest.mock("../../utils/api", () => jest.fn((url) => Promise.resolve(url === "random" ? [{ random: Math.random() }] : json)));
import { getSuggestions } from "./get-suggestions";

describe("getSuggestions", () => {
    it("requests returns the requested data", () => {
        expect.assertions(1);
        return getSuggestions("test").then((response) => expect(JSON.stringify(response)).toEqual(JSON.stringify(json)));
    });

    it("returns the same response on multiple identical requests from cache", () => {
        expect.assertions(1);
        let response1: string;
        return getSuggestions("random")
            .then((response) => (response1 = JSON.stringify(response)))
            .then(() =>
                getSuggestions("random").then((response2) => {
                    expect(response1).toEqual(JSON.stringify(response2));
                })
            );
    });
});
